<template>
  <div style="border-top: 1px solid #e2e2e2; padding: 20px 0">
    <ul style="display: flex; align-items: center; justify-content: center">
      <text style="color: #a2a2a2">银行账户：</text>
      <el-radio-group v-model="state.type" size="large">
        <el-radio-button label="以系统计算为准" :value="1">
          <el-tooltip
            class="box-item"
            effect="dark"
            content="该模式下，导入时员工服务费由系统根据员工所匹配的计算方式计算得出最终的服务费"
          >
            选择现有银行账户
          </el-tooltip>
        </el-radio-button>
        <el-radio-button label="以本次导入为准" value="2">
          <el-tooltip
            class="box-item"
            effect="dark"
            content="该模式下，导入时员工服务费以表格中填写值为准"
          >
            新增银行账户
          </el-tooltip>
        </el-radio-button>
      </el-radio-group>
    </ul>
    <el-form
      :model="state.bankModel"
      ref="formDom"
      label-position="top"
      style="width: 100%"
    >
      <el-form-item
        v-if="state.type === 1"
        label="银行账户"
        prop="bank_account_id"
        :rules="[
          { required: true, message: '请选择银行账户', trigger: 'blur' },
        ]"
      >
        <el-select
          v-model="state.bankModel.bank_account_id"
          size="large"
          placeholder="--请选择银行账户--"
        >
          <el-option
            v-for="item in state.bankAccountData"
            :key="item"
            :label="item.name + '(' + item.account + ')'"
            :value="item.id"
          />
          <template #footer>
            <el-button size="small" @click="onLoadBankAccount()">
              刷新
            </el-button>
          </template>
        </el-select>
      </el-form-item>
      <template v-else>
        <el-form-item
          label="账户名称"
          prop="name"
          :rules="[{ required: true, message: '请填写名称', trigger: 'blur' }]"
        >
          <el-input v-model="state.bankModel.name"></el-input>
        </el-form-item>

        <el-form-item
          label="账号"
          prop="account"
          :rules="[{ required: true, message: '请填写账号', trigger: 'blur' }]"
        >
          <el-input v-model="state.bankModel.account"></el-input>
        </el-form-item>
        <el-form-item
          label="开户行"
          prop="opening_bank"
          :rules="[
            { required: true, message: '请填写开户行', trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.bankModel.opening_bank"></el-input>
        </el-form-item>
      </template>
      <el-form-item
        label="数据文件"
        prop="file"
        :rules="[
          { required: true, message: '请选择数据文件', trigger: 'blur' },
        ]"
      >
        <ul style="display: flex; align-items: center; width: 100%">
          <el-input
            :value="state.bankModel.file?.name"
            size="large"
            placeholder="--请选择文件--"
            readonly
          ></el-input>
          <el-upload
            action="#"
            :show-file-list="false"
            ref="uploadDom"
            accept=".xlsx"
            :auto-upload="false"
            :on-change="onFileChange"
          >
            <template #default>
              <el-button type="primary" size="large" style="margin-left: 10px">
                选择文件
              </el-button>
            </template>
          </el-upload>
        </ul>
      </el-form-item>
    </el-form>
  </div>
  <div style="display: flex; align-items: center; justify-content: center">
    <el-button type="success" @click="onSubmit">确定导入</el-button>
    <el-button type="warning" @click="onDownLoad">模板下载</el-button>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  bankreceived_download,
  bankreceived_import,
} from "@/http/bankreceived";
import { bankaccount_add } from "@/http/bankaccount";
import { data_bankaccount_select } from "@/http/data";
import { ElMessage } from "element-plus";
import { post_response } from "@/utils/qFormat";
export default {
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      selectFile: {},
      bankModel: {},
      type: 1,
    });
    onMounted(() => {
      onLoadBankAccount();
    });

    const onLoadBankAccount = () => {
      data_bankaccount_select().then((res) => {
        if (res.status == 200) state.bankAccountData = res.data.data?.list;
      });
    };

    //选择文件
    const onFileChange = (file) => {
      state.bankModel.file = file;
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (state.type == 1) {
            onPost();
          } else {
            const { name, account, opening_bank } = state.bankModel;
            bankaccount_add({ name, account, opening_bank }).then((res) => {
              if (res.status == 200) {
                state.bankModel.bank_account_id = res.data.data?.id;
                onPost();
              }
            });
          }
        }
      });
    };

    const onPost = () => {
      const formData = new FormData();
      //把接口需要的参数带进去
      formData.append("bank_account_id", state.bankModel.bank_account_id);
      formData.append("file", state.bankModel.file?.raw);
      bankreceived_import(formData).then((res) => {
        if (res.status == 200) {
          post_response(res, emit);
        }
      });
    };

    const onDownLoad = () => {
      bankreceived_download()
        .then((res) => {
          if (res.status == 200) {
            let fileName = decodeURI(
              res.headers["content-disposition"].split("=")[1]
            );

            //通过后台返回 的word文件流设置文件名并下载
            var blob = new Blob([res.data], {
              type: res.data.type,
            });
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
          }
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8"
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      onFileChange,
      onSubmit,
      onDownLoad,
      onLoadBankAccount,
      formDom,
    };
  },
};
</script>
<style scoped></style>
